var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"send-egift-panel-refund-policy"},[(!_vm.loading)?[_c('span',{staticClass:"send-egift-panel-refund-policy__policy-text",domProps:{"innerHTML":_vm._s(_vm.content)}})]:_c('common-loader',{staticStyle:{"padding":"100px 0"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }